import { Component, OnInit, OnDestroy } from '@angular/core';
import * as _ from 'lodash';
import { Router, ActivatedRoute } from '@angular/router';
import { FaqService } from '../rest/api/faq.service';
import {TranslateService} from '@ngx-translate/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit, OnDestroy {
  faqList: any;
  lang: any;
  pageLoader = true;

  constructor(
    private route: ActivatedRoute,
    public faqService: FaqService,
    public translateService: TranslateService,
    public router: Router,
    public sanitizer: DomSanitizer
  ) { }

  ngOnInit() {
    this.lang = this.translateService.currentLang ? this.translateService.currentLang :
    (localStorage.getItem('language') ? localStorage.getItem('language') : '');
    this.getAllFaq();

    // $(window).bind('load', () => {
    //     this.loadIframeCodes();
    // });
  }

  getAllFaq() {
    this.faqService.getFaqList(this.lang).subscribe((response: any) => {
      const faqList = response.data;
      if (faqList && faqList.length > 0) {
        this.faqList = _.map(faqList, (data) => {
          // if (data.description) {
          //   data.description = this.sanitizer.bypassSecurityTrustHtml(data.description);
          // }

          // if (data.sub_pages && data.sub_pages.length > 0) {
          //   const subPages = _.map(faqList, (subdata) => {
          //     if (subdata.description) {
          //       subdata.description = this.sanitizer.bypassSecurityTrustHtml(subdata.description);
          //     }
          //     return subdata;
          //   });
          //   data.sub_pages = subPages;
          // }
          return data;
        });
      }
      this.faqList = _.orderBy(faqList, ['published_at'], ['desc']);
      this.pageLoader = false;
      this.loadIframeCodes();
  }, err => {
    this.pageLoader = false;
    this.router.navigate(['/']);
  });
  }

  convertHtml(html) {
    // console.log('hrml', html);
    // return html;
    // return html.replace('SafeValue must use [property]=binding: ', '');
    return this.sanitizer.bypassSecurityTrustHtml(html);
  }

  getIframeContent() {
    if ($('iframe') && $('iframe')[0]) {
      return $('iframe')[0].innerHTML;
    }
    return '';
  }

  getDescriptionWithIframe(pages) {
    if (pages.iframe_code && pages.iframe_code !== '') {
      return pages.description.replace('/<iframe\s+.*?\s+src=(".*?").*?<\/iframe>/', '');
    }
    return pages.description;
    //   const index = pages.description.indexOf( '</iframe>', pages.description.indexOf( '</iframe>' ) );
    //   const firstChunk = index >= 0 ? pages.description.substr( 0, index ) : pages.description.substr( index );
    //   if ( index >= 0 ) {
    //     const description = `<pre class="iframe-div">${ pages.iframe_code }</pre>
    //     ${firstChunk}
    //     ${pages.description.substr(index + 1)}
    //     `;
    //     return description;
    //   }
    // }
    // return pages.description;
  }

  loadIframeCodes() {
    setTimeout(() => {
      // tslint:disable-next-line:only-arrow-functions
      $.each( $('iframe'), function(key, value) {
        const pre = document.createElement('pre');
        pre.textContent = value.outerHTML;
        pre.className = 'iframe-div';
        value.before(pre);
        $(pre).insertBefore(value);
      });
    }, 1000);
  }

  removeIframeCodes() {
    const iframes = document.querySelectorAll('iframe');
    let i;
    for (i = 0; i < iframes.length; i++) {
        iframes[i].parentNode.removeChild(iframes[i]);
    }
  }

  ngOnDestroy() {
    this.removeIframeCodes();
  }

}
